import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { Fragment, useMemo, useState } from "react"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"

const ITEM_HEIGHT = 48

interface ComponentProps {
    hours: string,
    minutes: string,
    onchange: (data: any) => void
}

const useStyles = makeStyles((theme: Theme) => ({
    timeSelect: {
        marginTop: 2,
    },
    time: {
        cursor: "pointer",
    },
}))

export default function DateSelect(props: ComponentProps) {
    const classes = useStyles()
    const { hours, minutes, onchange } = props
    const [ selectType, setSelectType ] = useState("")
    const [ anchorEl, setAnchorEl ] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleClick = (event: React.MouseEvent<HTMLElement>, selectType: string) => {
        setAnchorEl(event.currentTarget)
        setSelectType(selectType)
    }

    const handleClose = (option: string | number) => {
        setAnchorEl(null)
        onchange({
            [selectType]: option,
        })
    }
    const options = useMemo(() => {
        const options = []
        const max = selectType === "hours" ? 24 : 60
        for (let i = 0; i < max; i++) {
            options.push((i < 10 ? `0${i}` : i))
        }
        return options
    }, [selectType])
    return (
        <Fragment>
            <div className={classes.timeSelect}>
                <span
                    className={classes.time}
                    onClick={(event) => handleClick(event, "hours")}
                >{hours}</span>
                <span>:</span>
                <span
                    className={classes.time}
                    onClick={(event) => handleClick(event, "minutes")}
                >{minutes}</span>
            </div>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: 200,
                    },
                }}
            >
                {options.map((option) => (
                    <MenuItem key={option} selected={option === "Pyxis"} onClick={() => handleClose(option)}>
                        {option}
                    </MenuItem>
                ))}
            </Menu>
        </Fragment>
    )
}
